import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { recievingHelp } from '../../actions/queueActions';
import { HTTP_SERVER_URL } from '../../configuration';

export const ModalType = 'SELECT_HELPER_MODAL';

interface OnDutyTa {
  username: string;
  realname: string;
}

function getToken(): string {
  const raw = localStorage.getItem('Token');
  return raw ? JSON.parse(raw).token : '';
}

export default (props: any): JSX.Element => {
  const queueName: string = props.queueName;
  const dispatch = useDispatch();

  const [tas, setTas] = useState<OnDutyTa[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!props.show) return;
    setLoading(true);
    fetch(`${HTTP_SERVER_URL}/api/queues/${encodeURIComponent(queueName)}/on_duty`, {
      headers: { Authorization: `Token ${getToken()}` }
    })
      .then(r => r.json())
      .then((data: OnDutyTa[]) => {
        setTas(data);
        setLoading(false);
      })
      .catch(() => {
        setTas([]);
        setLoading(false);
      });
  }, [props.show, queueName]);

  function selectTa(username: string): void {
    dispatch(recievingHelp(queueName, true, username));
    props.onHide();
  }

  return (
    <Modal show={props.show} onHide={props.onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Who is helping you?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-3">Loading...</div>
        ) : tas.length === 0 ? (
          <div className="text-center py-3 text-muted">
            No TAs on duty — ask your TA to check in
          </div>
        ) : (
          <div className="d-grid gap-2">
            {tas.map(ta => (
              <button
                key={ta.username}
                className="btn btn-lg helper-ta-btn"
                onClick={() => selectTa(ta.username)}>
                {ta.realname}
              </button>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
